module.exports = __webpack_public_path__ + "img/性别-女.81c63c7b.png";